export type ParsedDecimal = { kind: "empty" } | { kind: "number"; value: number } | { kind: "notANumber" };

const plainDecimal = /^-?(\d+([.,]\d*)?|[.,]\d+)$/;
const spaceGroupedDecimal = /^-?\d{1,3}( \d{3})+([.,]\d*)?$/;

export const parseDecimalInput = (
  text: string,
  { allowSpaceGrouping = false }: { allowSpaceGrouping?: boolean } = {},
): ParsedDecimal => {
  const trimmed = text.replace(/[\u00a0\u202f]/g, " ").replace(/\u2212/g, "-").trim();
  if (trimmed === "") return { kind: "empty" };
  const isReadable = plainDecimal.test(trimmed) || (allowSpaceGrouping && spaceGroupedDecimal.test(trimmed));
  if (!isReadable) return { kind: "notANumber" };
  return { kind: "number", value: Number.parseFloat(trimmed.replace(/ /g, "").replace(",", ".")) };
};

export const formatDecimalForInput = (value: number): string =>
  value.toLocaleString("nb-NO", { maximumFractionDigits: 20 });
